import { createContext, ReactNode, useContext, useState } from 'react';

const IngestionScheduleContext = createContext<{
  ingestionScheduleIsOpen: boolean;
  setIngestionScheduleIsOpen: (value: boolean) => void;
}>({
  ingestionScheduleIsOpen: false,
  setIngestionScheduleIsOpen: () => {},
});

export const IngestionScheduleProvider = ({ children }: { children: ReactNode }) => {
  const [ingestionScheduleIsOpen, setIngestionScheduleIsOpen] = useState(false);

  return (
    <IngestionScheduleContext.Provider
      value={{ ingestionScheduleIsOpen, setIngestionScheduleIsOpen }}
    >
      {children}
    </IngestionScheduleContext.Provider>
  );
};

export const useIngestionSchedule = () => {
  const ingestionSchedule = useContext(IngestionScheduleContext);
  if (ingestionSchedule === undefined) {
    throw Error('You must wrap component in context provider');
  }
  return ingestionSchedule;
};
